export interface BoxReferenceLike {
  id: string;
  name?: string | null;
}

const BOX_ID_PATTERN = /^box_[a-zA-Z0-9-_]+$/;

function normalizeValue(value: string): string {
  return value.trim();
}

export function formatBoxReferenceLabel(box: BoxReferenceLike): string {
  const id = normalizeValue(box.id);
  const name = normalizeValue(String(box.name || ""));
  if (name) {
    return name;
  }
  if (id) {
    return "Без названия";
  }
  return "";
}

export function resolveBoxReferenceInput(
  input: string,
  boxes: readonly BoxReferenceLike[],
): string {
  const normalized = normalizeValue(input);
  if (!normalized) {
    return "";
  }

  if (BOX_ID_PATTERN.test(normalized)) {
    return normalized;
  }

  const idMatch = normalized.match(/\b(box_[a-zA-Z0-9-_]+)\b/);
  if (idMatch && BOX_ID_PATTERN.test(idMatch[1])) {
    return idMatch[1];
  }

  const lowered = normalized.toLocaleLowerCase("ru-RU");
  const byName = boxes.find((box) => {
    const boxName = normalizeValue(String(box.name || ""));
    return boxName && boxName.toLocaleLowerCase("ru-RU") === lowered;
  });
  if (byName) {
    return normalizeValue(byName.id);
  }

  return normalized;
}

export function formatBoxReferenceInputValue(
  value: string,
  boxes: readonly BoxReferenceLike[],
): string {
  const normalizedId = resolveBoxReferenceInput(value, boxes);
  if (!normalizedId || !BOX_ID_PATTERN.test(normalizedId)) {
    return normalizeValue(value);
  }

  const found = boxes.find((box) => normalizeValue(box.id) === normalizedId);
  if (!found) {
    return normalizedId;
  }

  return formatBoxReferenceLabel(found);
}
